import type { RelatedLink } from '@/modules/Content/interface/Content';
import type { FC } from 'react';
import { ChevronRight } from '@eqi-investimentos/icons/web';
import { Button, Flex, Link, Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { IfRender } from '@/utils/jsx';

export const ContentRelatedLinks: FC<ContentRelatedLinksProps> = ({
  relatedLinks = [],
}) => {
  const t = useT();

  return (
    <IfRender condition={!!relatedLinks?.length}>
      <Flex
        borderRadius="xs"
        p="2xl"
        bgColor="background.brandLight"
        flexDir="column"
      >
        <Text>{t('screens.content.relatedLinks')}</Text>
        {relatedLinks
          .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0))
          .map((relatedLink, index, { length }) => (
            <Button
              key={relatedLink.url}
              variant="naked"
              justifyContent="left"
              leftIcon={<ChevronRight />}
              borderBottom={index < length - 1 ? '1px solid' : undefined}
              borderColor="border.secondary"
              borderRadius="0"
              pt="2xl"
              py={index < length - 1 ? '2xl' : undefined}
            >
              <Link
                href={relatedLink.url}
                target="_blank"
                rel="noopener noreferrer"
                textDecoration="underline"
                fontSize="xl"
                fontWeight="bold"
                lineHeight="xl"
                whiteSpace="normal"
                _hover={{ textDecoration: 'underline' }}
              >
                {relatedLink.title}
              </Link>
            </Button>
          ))}
      </Flex>
    </IfRender>
  );
};

type ContentRelatedLinksProps = {
  relatedLinks?: RelatedLink[];
};
